import { Button } from '@/components/ui/button';
import { BRAND_PRIMARY_BTN_CLASS } from '@/constants/brandColors';
import { cn } from '@/lib/utils';

/**
 * Shared footer for every date-picker panel in the app (Home, IndexMinimal,
 * GoogleFlightsSearch, Search — desktop popover and mobile sheet alike).
 * Replaces eight hand-rolled copies of the same rule text + a stark white
 * "Done" that ignored the theme. The 21-day rule reads as quiet metadata;
 * the payoff line ("further out = more time to pay") carries the brand's
 * positive framing; Done is the standard brand primary pill.
 */
export default function CalendarDock({ onDone, note = null, className }) {
  return (
    <div className={cn('border-t border-white/10 p-3 pt-3', className)}>
      <div className="mb-2.5 text-center leading-snug">
        {note || (
          <>
            <p className="text-[11px] font-normal text-white/45">Must book 21+ days in advance.</p>
            <p className="mt-0.5 text-[11px] font-normal text-emerald-300/80">
              The further out you book, the more time you&apos;ll have to pay.
            </p>
          </>
        )}
      </div>
      <Button
        type="button"
        onClick={onDone}
        className={cn(BRAND_PRIMARY_BTN_CLASS, 'w-full h-11 rounded-full')}
      >
        Done
      </Button>
    </div>
  );
}
